import React, { useEffect, useState, constructor } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination } from 'antd';
import { Table, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { ITeacher, listTeachers, createTeacher, updateTeacher, deleteTeacher, pageTeachers } from '../../service/api/teacher';
import { IStore, listStores } from '../../service/api/store';
import moment from 'moment';
import { ICardDefinition, listCardDefinitions } from '../../service/api/cardDefinition';
import { ICard, createCard } from '../../service/api/card';
import CardList from '../card/CardList';
import { Link } from 'react-router-dom';
import PunchRecordList from '../card/PunchRecordList';
import { FormInstance } from 'antd/lib/form/Form';
const { confirm } = Modal;
const { Option } = Select;
// import queryString from 'query-string';

// const values = queryString.parse(window.location.search)

function getUrlParam(name:string, str:string) {
  const paramUrl = str.split('?');
  const params = paramUrl[1].split('&');
  for (var i=0;i<params.length;i++){
    const value = params[i].split('=');
    if(value[0]==name){
      return value[1];
    }
   }
  return null;
}

const StudentCardView = (props: any) => {
  const [teachers, setTeachers] = useState<ITeacher[]>();
  const [stores, setStores] = useState<IStore[]>();
  const [cardDefinitions, setCardDefinitions] = useState<ICardDefinition[]>();
  const [teacherDetail, setTeacherDetail] = useState<ITeacher>();
  const [buyTeacherDetail, setBuyTeacherDetail] = useState<ITeacher>();
  const [teacherVisible, setTeacherVisible] = useState(false);
  const [buyVisible, setBuyVisible] = useState(false);
  const [pageNum, setPageNum] = useState(1);
  const [pageTotal, setPageTotal] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const formRef = React.createRef<FormInstance>();
  const buyformRef = React.createRef<FormInstance>();
  // console.log('csn:'+getUrlToken ('token',props.location.search));
  // console.log('csn:'+window.location.href);
  // console.log('csn:'+window.location.search);

  // //  结果测试
  // constructor(props){
  //   const token = getUrlToken ('token',props.location.search);
  //   console.log(token );
  // }

  return (
    <div className="gutter-example">
      <BreadcrumbCustom breads={[<Link to={'/app/student'}>学员管理</Link>,'打卡记录']} />
      <PunchRecordList studentId={getUrlParam('studentId',window.location.href)}/>
    </div>
  );
};

export default StudentCardView;
